import React from "react"
import Layout from "../../components/layouts/layout"

import "./patientinfo.css"
import PropTypes from "prop-types"
import { useTrackFormStepArrival } from "../../utils/analytics"
import ProgressBar from "utils/stepper"
import MorningApptBanner from "utils/morningApptBanner"

const Patientinfo = ({ nextStep, setUser, user }) => {
  useTrackFormStepArrival("patient_info")
  function onChangeValue(event) {
    setUser({
      ...user,
      [event.target.name]: event.target.value,
    })
  }
  const NextPageBtn = () => {
    console.log(user.seeking_evaluation)
    nextStep()
  }
  return (
    <>
      <Layout>
        <section className="progress-bar-section">
          <div className="progress-bar-wrapper">
            <ProgressBar activeStep={0} />
          </div>
        </section>
        <MorningApptBanner />
        <section className="patient-check-section">
          <div className="container">
            <div className="patient-heading">
              <h4> Patient Information</h4>
              <p>
                {" "}
                At Cortica, we believe every child has a unique path to reach
                their highest potential. Please tell us a little bit about them.
              </p>
            </div>
            <form className="patient-formSection" onSubmit={NextPageBtn}>
              <div className="patient-wrapper1">
                <div className="patient-form-wrapper checkinSection">
                  <div className="row align-items-center">
                    <div className="col-md-9">
                      <h4>
                        1. Has your child been diagnosed with autism by a
                        medical doctor or psychologist?
                      </h4>
                    </div>
                    <div className="col-md-3 text-right">
                      <div className="d-flex" onChange={onChangeValue}>
                        <label className="mr-3">
                          <input
                            defaultChecked={
                              user.previously_diagnosed === "true"
                            }
                            id="defaultCheck1"
                            name="previously_diagnosed"
                            onChange={null}
                            type="radio"
                            value="true"
                          />
                          &nbsp;<span>Yes</span>
                        </label>
                        <label>
                          <input
                            defaultChecked={
                              user.previously_diagnosed === "false"
                            }
                            id="defaultCheck2"
                            name="previously_diagnosed"
                            onChange={null}
                            type="radio"
                            value="false"
                          />
                          &nbsp;<span>No</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="patient-form-wrapper checkinSection">
                  <div className="row align-items-center">
                    <div className="col-md-9">
                      <h4>
                        2. Are you seeking a diagnostic evaluation to see if
                        your child has autism?
                      </h4>
                    </div>
                    <div className="col-md-3 text-right">
                      <div className="d-flex" onChange={onChangeValue}>
                        <label className="mr-3">
                          <input
                            defaultChecked={user.seeking_evaluation === "true"}
                            id="defaultCheck"
                            name="seeking_evaluation"
                            onChange={null}
                            type="radio"
                            value="true"
                          />
                          &nbsp;<span>Yes</span>
                        </label>
                        <label>
                          <input
                            defaultChecked={user.seeking_evaluation === "false"}
                            id="defaultCheck4"
                            name="seeking_evaluation"
                            onChange={null}
                            type="radio"
                            value="false"
                          />
                          &nbsp;<span>No</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="patient-form-wrapper checkinSection">
                  <div className="row align-items-center">
                    <div className="col-md-9">
                      <h4>
                        {" "}
                        Are you seeking therapy services for any of the
                        following:
                      </h4>
                      <p>
                        Autism; ADHD; developmental delay (such as delays in
                        speech, motor, or cognitive development); intellectual,
                        cognitive, or learning disability; sensory processing
                        disorder; cerebral palsy; genetic syndrome; or epilepsy.
                      </p>
                    </div>
                    <div className="col-md-3 text-right">
                      <div className="d-flex" onChange={onChangeValue}>
                        <label className="mr-3">
                          <input
                            defaultChecked={user.seeking_diagnoses === "true"}
                            name="seeking_diagnoses"
                            onChange={null}
                            type="radio"
                            value="true"
                          />
                          &nbsp;<span>Yes</span>
                        </label>
                        <label>
                          <input
                            defaultChecked={user.seeking_diagnoses === "false"}
                            name="seeking_diagnoses"
                            onChange={null}
                            type="radio"
                            value="false"
                          />
                          &nbsp;<span>No</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="btn-wrapper my-4 text-right">
                  <button className="btn btn-yellow" type="submit">
                    Next Step
                  </button>
                </div>
              </div>
            </form>
          </div>
        </section>
      </Layout>
    </>
  )
}
Patientinfo.propTypes = {
  nextStep: PropTypes.func.isRequired,
  setUser: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
}
export default Patientinfo
